import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import { getAuth } from 'firebase/auth';
import { getStorage } from 'firebase/storage';
import { getAnalytics, isSupported } from 'firebase/analytics';

// Firebase configuration
// TODO: Replace with actual Firebase config from Firebase Console
const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firestore
export const db = getFirestore(app);

// Auth and Storage back the admin console at /admin. Public visitors never
// authenticate; only signed-in administrators can write content or upload media.
//
// Both are initialized defensively. getAuth throws outright when the API key is
// missing or malformed, and the public site must never go down because the
// admin console is misconfigured. When these are null the site renders normally
// and the console reports the configuration problem instead.
function safeInit(factory, name) {
  try {
    return factory(app);
  } catch (error) {
    console.warn(`Firebase ${name} unavailable. The admin console will be disabled.`);
    return null;
  }
}

export const auth = safeInit(getAuth, 'Auth');
export const storage = safeInit(getStorage, 'Storage');

// Initialize Analytics with guard for pre-rendering
// Wrapped in try-catch to suppress errors if Analytics not enabled in Firebase Console
if (typeof navigator !== 'undefined' && navigator.userAgent !== 'ReactSnap') {
  isSupported().then((supported) => {
    if (supported) {
      try {
        getAnalytics(app);
      } catch (error) {
        // Analytics not configured - safe to ignore
        console.log('Firebase Analytics not enabled (optional)');
      }
    }
  }).catch(() => {
    // Silently fail if Analytics not available
  });
}

export default app;
